/* Market Spas — consented interaction counts. Reuses the existing GA4 tag in GA4 mode. */
(function (root, doc) {
  'use strict';
  if (root.MSStoreTrackingInstalled) return;
  var script = doc.currentScript;
  var endpoint = script && script.getAttribute('data-ms-store-endpoint');
  var ga4 = script && script.getAttribute('data-ms-store-ga4');
  if (ga4 && !/^G-[A-Z0-9]+$/.test(ga4)) return;
  if (!ga4) { try { if (!endpoint || new URL(endpoint).protocol !== 'https:') return; } catch (_) { return; } }
  root.MSStoreTrackingInstalled = true;
  var pending = new Set(), inflight = new Set(), viewed = new WeakSet(), queuedViews = new WeakSet();
  var actions = ['store_select', 'store_page_open', 'directions_click', 'call_click', 'email_click', 'website_click'];
  var surfaces = ['locator_map', 'locator_list', 'contact_map', 'contact_list', 'store_map', 'store_list', 'store_page', 'store_grid', 'maintenance_map', 'maintenance_list'];
  function googleTag() {
    if (typeof root.gtag === 'function') return root.gtag;
    // Google & YouTube loads the Google tag without necessarily exporting its helper.
    // Reuse its standard data layer. Never configure a second tag or page_view.
    if (root.dataLayer && typeof root.dataLayer.push === 'function') return function () { root.dataLayer.push(arguments); };
    return null;
  }
  function allowed() {
    try {
      var privacy = root.Shopify && root.Shopify.customerPrivacy;
      return !!privacy && privacy.analyticsProcessingAllowed() === true && privacy.currentVisitorConsent().analytics === 'yes';
    } catch (_) { return false; }
  }
  function clearPending() {
    pending.forEach(function (timer) { root.clearTimeout(timer); }); pending.clear(); queuedViews = new WeakSet();
    inflight.forEach(function (controller) { controller.abort(); }); inflight.clear();
  }
  function enqueue(node, action, onSent) {
    if (!allowed() || pending.size >= 25) return;
    if (ga4 ? !googleTag() : (!root.crypto || !root.crypto.randomUUID || !root.fetch)) return;
    var owner = node.closest('[data-ms-store-id]'), placement = node.closest('[data-ms-store-surface]');
    var storeId = owner && owner.getAttribute('data-ms-store-id'), surface = placement && placement.getAttribute('data-ms-store-surface');
    if (!/^gid:\/\/shopify\/Metaobject\/\d{1,30}$/.test(storeId || '') || surfaces.indexOf(surface) < 0) return;
    var pagePath = root.location.pathname;
    var storeName = (owner.getAttribute('data-ms-store-name') || storeId).slice(0, 100);
    var body = {version: 1, eventId: ga4 ? '' : root.crypto.randomUUID(), storeId: storeId, action: action, surface: surface, pagePath: pagePath, occurredAt: new Date().toISOString()};
    var timer = root.setTimeout(function () {
      pending.delete(timer);
      if (!allowed()) return;
      if (ga4) {
        var tag = googleTag(); if (!tag) return;
        try {
          tag('event', 'ms_' + action, {
            send_to: ga4, ms_store_id: storeId, ms_store_name: storeName,
            ms_store_surface: surface, page_location: root.location.origin + pagePath,
            page_referrer: ''
          });
          if (onSent) onSent();
        } catch (_) { /* Navigation must keep working if the tag fails. */ }
        return;
      }
      var controller = new AbortController(); inflight.add(controller);
      try {
        root.fetch(endpoint, {method: 'POST', body: JSON.stringify(body), headers: {'Content-Type': 'text/plain;charset=UTF-8'}, mode: 'cors', credentials: 'omit', referrerPolicy: 'no-referrer', keepalive: true, signal: controller.signal})
          .catch(function () { /* Never retry or obstruct navigation. */ })
          .finally(function () { inflight.delete(controller); });
        if (onSent) onSent();
      } catch (_) { inflight.delete(controller); }
    }, 0);
    pending.add(timer);
    return true;
  }
  function interaction(event) {
    if (!event.isTrusted || !event.target || !event.target.closest || !allowed()) return;
    if (event.type === 'keydown' && (event.repeat || (event.key !== 'Enter' && event.key !== ' '))) return;
    if (event.type !== 'keydown' && event.button > 1) return;
    var actionNode = event.target.closest('[data-ms-store-action]');
    if (!actionNode) return;
    var action = actionNode.getAttribute('data-ms-store-action');
    if (actions.indexOf(action) < 0 || (event.type === 'auxclick' && action === 'store_select')) return;
    // An uninstrumented link, disclosure or form control inside a selectable card is not a selection.
    var interactive = event.target.closest('a,button,summary,details,input,select,textarea');
    if (interactive && interactive !== actionNode && action === 'store_select') return;
    // Native anchors/buttons produce their own click on keyboard activation.
    if (event.type === 'keydown' && (interactive || action !== 'store_select' || actionNode.getAttribute('role') !== 'button')) return;
    enqueue(actionNode, action);
  }
  // Capture handles map libraries that stop bubbling and always emits only the nearest action.
  doc.addEventListener('click', interaction, true);
  doc.addEventListener('auxclick', function (e) { if (e.button === 1) interaction(e); }, true);
  doc.addEventListener('keydown', interaction, true);
  function pageViews() {
    if (!allowed()) return;
    doc.querySelectorAll('[data-ms-store-page-view]').forEach(function (node) {
      if (!viewed.has(node) && !queuedViews.has(node)) {
        if (enqueue(node, 'store_page_view', function () { viewed.add(node); queuedViews.delete(node); })) queuedViews.add(node);
      }
    });
  }
  doc.addEventListener('visitorConsentCollected', function () { clearPending(); if (allowed()) pageViews(); });
  doc.addEventListener('shopify:section:load', pageViews);
  root.addEventListener('load', pageViews);
  function initialize() {
    if (root.Shopify && root.Shopify.customerPrivacy) { pageViews(); return; }
    if (root.Shopify && root.Shopify.loadFeatures) root.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) { if (!error) pageViews(); });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', initialize); else initialize();
})(window, document);
